export const JOURNEY_FUNDING_OPTIONS = [
  ["student_finance", "Student Finance", "Assess relevant Student Finance criteria"],
  ["apprenticeship_employer", "Apprenticeship / employer funded", "Work-based or employer-supported route"],
  ["employer", "Employer funding", "Your employer may sponsor the course"],
  ["scholarship_bursary", "Scholarship / bursary", "Provider or external funding"],
  ["self_funded", "Self-funded", "You intend to pay directly"],
  ["other", "Other", "Another funding route"],
  ["not_sure", "I’m not sure", "Help me determine possible routes"],
];

export const FUNDING_OPTIONS = [
  ["student_finance", "Student Finance"], ["apprenticeship_employer", "Apprenticeship / employer funded"],
  ["employer", "Employer funding"], ["scholarship_bursary", "Scholarship / bursary"], ["self_funded", "Self-funded"],
  ["other", "Other"], ["not_sure", "I’m not sure"],
];

export const UK_STATUS_OPTIONS = [
  ["british_irish_citizen", "British or Irish citizen"], ["settled_status", "Settled status"],
  ["pre_settled_status", "Pre-settled status"], ["indefinite_leave", "Indefinite leave to remain"],
  ["visa_limited_leave", "Visa / limited leave"], ["other_permission", "Other permission to stay"], ["not_sure", "I’m not sure"],
];

export const JOURNEY_EDUCATION_OPTIONS = [
  ["unknown", "I don’t know the UK equivalent"], ["no_formal", "No formal qualification"],
  ["gcse_level_2", "GCSE / Level 2"], ["level_3", "A level / Level 3"], ["professional", "Professional qualification"],
  ["undergraduate", "Bachelor's degree"], ["postgraduate", "Postgraduate qualification"],
];

export const EDUCATION_OPTIONS = [
  ["no_formal", "No formal qualification"], ["gcse_level_2", "GCSE / Level 2"], ["level_3", "A level / Level 3"],
  ["professional", "Professional qualification"], ["undergraduate", "Bachelor's degree"], ["postgraduate", "Postgraduate qualification"],
];

export const UNKNOWN_EDUCATION_OPTION = ["unknown", "I don’t know the UK equivalent"];

export const AWARD_OPTIONS = [
  ["awarded", "Qualification awarded"], ["currently_studying", "Currently studying"], ["partial", "Partially completed"],
  ["not_awarded", "Completed study but qualification not awarded"], ["no_formal_diploma", "No formal diploma"], ["documents_unavailable", "Documents unavailable"],
];

export const EVIDENCE_OPTIONS = [
  ["official_documents", "Official diploma/transcript available"], ["transcript_only", "Transcript available"],
  ["other_evidence", "Other official evidence"], ["documents_unavailable", "Documents unavailable"], ["unknown", "I’m not sure"],
];

export const JOURNEY_ENGLISH_OPTIONS = [
  ["native", "Native or fluent English speaker"], ["degree_taught_in_english", "Education taught in English"],
  ["valid_test", "Accepted English test available"], ["no_current_evidence", "No current evidence"],
  ["needs_assessment", "I’d like an indicative assessment"], ["not_sure", "I’m not sure"],
];

export const ENGLISH_OPTIONS = [
  ["native", "Native or fluent English speaker"], ["degree_taught_in_english", "Education taught in English"],
  ["valid_test", "Accepted English test available"], ["no_current_evidence", "No current evidence"],
  ["needs_assessment", "Use OpenDegree indicative assessment"], ["not_sure", "I’m not sure"],
];

export const ENGLISH_VOCABULARY_OPTIONS = [["cleaned", "cleaned"], ["boiled", "boiled"], ["painted", "painted"], ["borrowed", "borrowed"]];

export const LOCATION_OPTIONS = [["uk", "UK"], ["outside_uk", "Outside the UK"]];

export const RIGHT_TO_WORK_OPTIONS = [["yes", "Yes"], ["no", "No"], ["not_sure", "I’m not sure"]];

export const OPPORTUNITY_TYPE_OPTIONS = [
  ["higher_education", "Higher Education"], ["apprenticeship", "Apprenticeship"],
  ["professional_qualification", "Professional Qualification"], ["online_learning", "Online Learning"], ["training", "Training"],
];

export const QUALIFICATION_LEVEL_OPTIONS = [
  ["undergraduate", "Undergraduate"], ["postgraduate", "Postgraduate"], ["degree_apprenticeship", "Degree apprenticeship"],
  ["professional", "Professional"], ["training", "Training"],
];

export const STUDY_MODE_OPTIONS = [["Full-time", "Full-time"], ["Part-time", "Part-time"], ["Flexible", "Flexible"]];

export const suggestedFundingIntentions = (answers) => {
  const type = answers.opportunity_type;
  const level = answers.qualification_level;
  const suggestions = [];
  if (type === "apprenticeship") suggestions.push("apprenticeship_employer");
  if ((type === "higher_education" || type === "online_learning") && (level === "undergraduate" || level === "postgraduate")) suggestions.push("student_finance");
  if (type === "professional_qualification" || type === "training") suggestions.push("employer");
  suggestions.push("self_funded");
  return suggestions;
};


export const LEVEL_FROM_AI = { "Level 2": "gcse_level_2", "Level 3": "level_3", "Level 4": "professional", "Level 5": "professional", "Level 6": "undergraduate", "Level 7": "postgraduate" };
